/* eslint-disable arrow-body-style */
import React from 'react';

function WelcomeNoResults() {
  return (
    <div className="text-center w-full text-gray-500 font-normal text-xl mt-16">
      No results... try again ? 🤔
    </div>
  );
}

export default WelcomeNoResults;
